module.exports = __webpack_public_path__ + "static/img/about5.5505a24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/about5.jpg
// module id = /xBX
// module chunks = 3